import { render, staticRenderFns } from "./AmbassadorsDI.vue?vue&type=template&id=4d566f18"
import script from "./AmbassadorsDI.vue?vue&type=script&setup=true&lang=js"
export * from "./AmbassadorsDI.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports